import React, { memo } from 'react';
import { lowercaseHardMutations } from './hardMutations';
import { mutationTypes } from './mutationUtils';
import ExplanationMutation from './ExplanationMutation';
import ListSubTitle from './ListSubTitle';
import ListParagraph from './ListParagraph';

const ExplanationHardMutation = () => {
  return (
    <ExplanationMutation lowercaseMutations={lowercaseHardMutations} mutationType={mutationTypes.HARD}>
      <ul>
        <li>
          <ListSubTitle>ho, hoc'h</ListSubTitle>
          <ListParagraph>
            Digorit ho kenoù.<br />
            Pelec'h emañ ho kwerenn?<br />
            Serrit ho peg.<br />
            Echu eo ho tevezh?<br />
          </ListParagraph>
        </li>
      </ul>
    </ExplanationMutation>
  );
};

export default memo(ExplanationHardMutation);
